module.exports = __webpack_public_path__ + "static/media/thumbnail.bcfe270c.jpg";